import { render, staticRenderFns } from "./PaymentOrdersClaims.vue?vue&type=template&id=f95cf5e4&scoped=true&"
import script from "./PaymentOrdersClaims.vue?vue&type=script&lang=js&"
export * from "./PaymentOrdersClaims.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrdersClaims.vue?vue&type=style&index=0&id=f95cf5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95cf5e4",
  null
  
)

export default component.exports